import qs from 'qs';

export class RoutePaths {
  static login = {
    path: 'login',
    onNavigate: () => '/login',
  };
  static remember = {
    path: 'remember',
    onNavigate: () => '/remember',
  };
  static register = {
    path: 'register',
    onNavigate: () => '/register',
  };

  static messages = {
    path: 'messages/:threadId?/',
    onNavigate: () => '/messages/:threadId?/',
  };

  static card = {
    path: 'card/:id',
    onNavigate: (id: number) => `/card/${id}`,
  };

  static transactions = {
    path: 'card/:id/transactions',
    onNavigate: (id: number) => `/card/${id}/transactions`,
  };

  static statements = {
    path: 'card/:id/statements',
    onNavigate: (id: number) => `/card/${id}/statements`,
  };

  static supplementaryCard = {
    path: 'card/:id/request-supplementary-card',
    onNavigate: () => '/request-supplementary-card',
  };

  static lost = {
    path: 'card/:id/lost',
    onNavigate: () => '/card/:id/lost',
  };

  static limit = {
    path: 'card/:id/limit',
    onNavigate: () => '/card/:id/limit',
  };

  static pin = {
    path: 'card/:id/pin',
    onNavigate: () => '/card/:id/pin',
  };

  static profile = {
    path: 'profile/:id?/:section?',
    onNavigate: (
      params: { id?: string; section?: string },
      query?: {
        tab?: string;
        mode?: 'edit' | 'view';
        queryString?: string;
      },
    ) => {
      const { queryString, ...rest } = query ?? {};
      const search = queryString ? queryString : qs.stringify(rest, { addQueryPrefix: true });
      return `/profile/${params.id ?? ''}${params.section ? `${params.section}` : ''}${search}`;
    },
  };
}
